import { Box, Flex, Text } from '@weareberyl/design-system'
import { Popover, Typography } from 'antd'
import { ReactNode } from 'react'
import TabIcon, { TabIconIcon } from './TabIcon'

type TabTitleProps = {
  tabText: string
  icon: TabIconIcon
  hoverText?: string
}

const TabTitle = ({ tabText, icon, hoverText }: TabTitleProps) => {
  const Wrapper = ({ children }: { children: ReactNode }) =>
    hoverText ? (
      <Popover
        content={
          <Box width={300}>
            <Text variant="small" fontFamily="Hellix">
              {hoverText}
            </Text>
          </Box>
        }
        placement="bottom"
      >
        {children}
      </Popover>
    ) : (
      <>{children}</>
    )
  return (
    <Wrapper>
      <Flex flexWrap="nowrap" gridGap={2} alignItems="center">
        <TabIcon icon={icon} />
        <Box flex={1} pb="2px">
          <Typography.Text
            ellipsis
            strong
            style={{ fontSize: '1.2em', cursor: 'pointer' }}
          >
            {tabText}
          </Typography.Text>
        </Box>
      </Flex>
    </Wrapper>
  )
}

export default TabTitle
